import React from "react";
import { theme } from "antd";

/** What a menu item needs for this: the two things that carry the colour. */
interface DangerMenuItem {
  icon?: React.ReactNode;
  label?: React.ReactNode;
}

/**
 * Marks a menu item as destructive, the way this app marks them.
 *
 * The colour goes on the icon and the label and nowhere else: the row keeps
 * antd's ordinary hover and pressed grounds, so the only thing red is what the
 * item says.
 *
 * Not antd's `danger` prop, which is the obvious answer and the wrong one here.
 * antd disagrees with itself about what a destructive thing looks like — a
 * Button with `danger` and variant="text" lights its ground on hover, a Menu
 * item with `danger` keeps a neutral hover and turns its ground red only while
 * it is held down. Neither of those is what a red word in a menu should do, and
 * Menu has no token for the hover ground, so the choice was between fighting
 * antd's selectors and simply not asking it. This does not ask.
 *
 * colorError comes from the theme, so it follows a rebrand; the header's user
 * menu, the campaign preview and the campaign builder all mark log out and
 * delete through this, and cannot drift apart.
 */
export default function useDangerMenuItem() {
  const {
    token: { colorError },
  } = theme.useToken();

  return <T extends DangerMenuItem>(item: T): T => ({
    ...item,
    icon: item.icon ? (
      <span style={{ color: colorError }}>{item.icon}</span>
    ) : undefined,
    label: <span style={{ color: colorError }}>{item.label}</span>,
  });
}
